import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: `
    ion-segment[toBoolean][formControlName],
    ion-segment[toBoolean][formControl],
    ion-segment[toBoolean][ngModel]
  `
})
export class IonSegmentBooleanDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('ionChange', ['$event'])
  onIonChange(ev: CustomEvent) {
    ev.stopImmediatePropagation();

    const raw = ev.detail.value;
    const bool = (typeof raw === 'string')
      ? raw.toLowerCase() === 'true'
      : !!raw;

    this.ngControl.control!.setValue(bool);
  }
}
